function Loader({ message = "Loading..." }) {
  return <p className="state-message">{message}</p>;
}

export default Loader;
